"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignToJSON = exports.CampaignFromJSONTyped = exports.CampaignFromJSON = exports.instanceOfCampaign = void 0;
var runtime_1 = require("../runtime");
var Purchase_1 = require("./Purchase");
/**
 * Check if a given object implements the Campaign interface.
 */
function instanceOfCampaign(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaign = instanceOfCampaign;
function CampaignFromJSON(json) {
    return CampaignFromJSONTyped(json, false);
}
exports.CampaignFromJSON = CampaignFromJSON;
function CampaignFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'totalItemsQuantity': !(0, runtime_1.exists)(json, 'total_items_quantity') ? undefined : json['total_items_quantity'],
        'subtotal': !(0, runtime_1.exists)(json, 'subtotal') ? undefined : json['subtotal'],
        'shipping': !(0, runtime_1.exists)(json, 'shipping') ? undefined : json['shipping'],
        'tax': !(0, runtime_1.exists)(json, 'tax') ? undefined : json['tax'],
        'totalCollectedOnline': !(0, runtime_1.exists)(json, 'total_collected_online') ? undefined : json['total_collected_online'],
        'minQty': !(0, runtime_1.exists)(json, 'min_qty') ? undefined : json['min_qty'],
        'goalQty': !(0, runtime_1.exists)(json, 'goal_qty') ? undefined : json['goal_qty'],
        'buyupAmount': !(0, runtime_1.exists)(json, 'buyup_amount') ? undefined : json['buyup_amount'],
        'purchases': !(0, runtime_1.exists)(json, 'purchases') ? undefined : (json['purchases'].map(Purchase_1.PurchaseFromJSON)),
    };
}
exports.CampaignFromJSONTyped = CampaignFromJSONTyped;
function CampaignToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'total_items_quantity': value.totalItemsQuantity,
        'subtotal': value.subtotal,
        'shipping': value.shipping,
        'tax': value.tax,
        'total_collected_online': value.totalCollectedOnline,
        'min_qty': value.minQty,
        'goal_qty': value.goalQty,
        'buyup_amount': value.buyupAmount,
        'purchases': value.purchases === undefined ? undefined : (value.purchases.map(Purchase_1.PurchaseToJSON)),
    };
}
exports.CampaignToJSON = CampaignToJSON;
